//#region [IMPORT]

// === THIRD-PARTY ===
import React from 'react';

// *** MUI / STYLING ***
import { useTheme } from '@mui/material/styles';
import {
    Table,    
    TableBody,
    TableRow,
    TableCell,
    Paper,
    Button,
    Dialog,
    DialogTitle,
    DialogContent,   
    DialogActions,
    TableContainer,
    Typography,
} from '@mui/material';

//#endregion

//-----------------------------------------------------------------
function ShortcutDialog(props) {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const theme = useTheme();

  //#endregion

  //#region [STYLES]

  const _styles = {
    container: {
    },
    cell_name: {
      width: '20rem',
    },
    cell_shortcut: {
      width: '12rem',
    },
    cell_description: {

    }
  }

  const
  CONTAINER = {
    sx : _styles.container,
  },
  DIALOG = {
    sx             : _styles.container,
    maxWidth       : 'lg',
    open           : props.showPopupDialog,
    onClose        : handleClose,
    ariaLabelledby : 'form-dialog-title',
  },
  CELL_NAME = {
    sx : _styles.cell_name,
  },
  CELL_SHORTCUT = {
    sx : _styles.cell_shortcut,
  },
  CELL_DESCRIPTION = {
    sx : _styles.cell_description,
  },  
  BUTTON_CLOSE = {
    color    : 'primary'   ,
    onClick  : handleClose ,
    children : [ 'Close' ] ,
  }

  //#endregion

  //#region [MODIFY]

  //-----------------------------------------------------------------
  function handleClose() {
    //-----------------------------------------------------------------
    props.setShowPopupDialog(false);
  };

  //#endregion

  //#region [DISPLAY]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <div { ...CONTAINER } >
        <Dialog { ...DIALOG } >
          <DialogTitle id='form-dialog-title' variant='primary' sx={{ backgroundColor: theme.palette.background.secondary[theme.palette.mode] }}>Keyboard Shortcuts</DialogTitle>
          <DialogContent sx={{ width: '100%', backgroundColor: theme.palette.background.secondary[theme.palette.mode] }}>
            <Typography variant="h6" sx={{mt:1, mb:1}}>Global</Typography>
            <TableContainer component={Paper} >
              <Table>
                <TableBody> 
                  <TableRow>
                    <TableCell {...CELL_NAME       }><strong>Find</strong> (a document, etc.)</TableCell>
                    <TableCell {...CELL_SHORTCUT   }><strong>Ctrl + F</strong></TableCell>
                    <TableCell {...CELL_DESCRIPTION}>Opens search window in the browser: enter document name, keyword, document numcode, other label or field data.</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell {...CELL_NAME       }>Adjust the<strong> Zoom Level </strong>of the window</TableCell>
                    <TableCell {...CELL_SHORTCUT   }><strong>Ctrl + minus (-)</strong> <br/> or <br/> <strong>Ctrl + plus (+)</strong></TableCell>
                    <TableCell {...CELL_DESCRIPTION}>This is helpful if you are working on large monitor and want to see more fields in the left pane.</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell {...CELL_NAME       }><strong>Quick Submit</strong> Task</TableCell>
                    <TableCell {...CELL_SHORTCUT   }><strong>Alt + Enter</strong></TableCell>
                    <TableCell {...CELL_DESCRIPTION}><strong>Note:</strong> This only works if the submit button has been enabled (turns green), which occurs when all uncertain fields have been validated.</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
            <Typography variant="h6" sx={{mt:1, mb:1}}>Document Thumbnails</Typography>
            <TableContainer component={Paper}>
              <Table>
                <TableBody>
                  <TableRow>
                    <TableCell {...CELL_NAME       }><strong>Split document</strong></TableCell>
                    <TableCell {...CELL_SHORTCUT   }><strong>Ctrl + S</strong></TableCell>
                    <TableCell {...CELL_DESCRIPTION}>While a thumbnail of a following page is selected, pressing this shortcut will add a new document boundary. The new document will inherit the prior document's name.</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell {...CELL_NAME       }><strong>Merge documents</strong></TableCell>
                    <TableCell {...CELL_SHORTCUT   }><strong>Ctrl + M</strong></TableCell>
                    <TableCell {...CELL_DESCRIPTION}>While a thumbnail of a leading page is selected, pressing this shortcut will merge the selected document with, and become a following page of, the preceding document.</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
            <Typography variant="h6" sx={{mt:1, mb:1}}>Document Image</Typography>
            <TableContainer component={Paper}>
              <Table>
                <TableBody>
                  <TableRow>
                    <TableCell {...CELL_NAME       }><strong>Image Magnifier</strong></TableCell>
                    <TableCell {...CELL_SHORTCUT   }><strong>Left click</strong></TableCell>
                    <TableCell {...CELL_DESCRIPTION}>Displays a rectangular magnifier that zooms in on an image.</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell {...CELL_NAME       }><strong>Highlight data</strong></TableCell>
                    <TableCell {...CELL_SHORTCUT   }><strong>Right click</strong> + Drag</TableCell>
                    <TableCell {...CELL_DESCRIPTION}>
                      Before drawing, be sure that the corresponding data entry field is selected in the left panel.
                      <br/>It is recommended to start at the <strong>top-left position</strong> of the text you want to highlight, then draw down horizontally to the <strong>bottom-right</strong>.
                      <br/> If your system configuration includes the ability to highlight multiple entries for a data extraction field, repeat this process as necessary.
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell {...CELL_NAME       }><strong>Select a highlight</strong></TableCell>
                    <TableCell {...CELL_SHORTCUT   }><strong>Ctrl + Left click</strong></TableCell>
                    <TableCell {...CELL_DESCRIPTION}>Adds a border around the highlight to indicate its selection.<br/> Clicking again removes the selection.</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell {...CELL_NAME       }><strong>Remove a highlight</strong></TableCell>
                    <TableCell {...CELL_SHORTCUT   }><strong>Ctrl + Right click</strong></TableCell>
                    <TableCell {...CELL_DESCRIPTION}><strong>Highlight needs to be selected first.</strong> Removes the image highlight and coordinates from the field</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
            <Typography variant="h6" sx={{mt:1, mb:1}}>Fields</Typography>
            <TableContainer component={Paper}>
              <Table>
                <TableBody>
                  <TableRow>
                    <TableCell {...CELL_NAME       }><strong>Accept</strong> Field<strong> </strong></TableCell>
                    <TableCell {...CELL_SHORTCUT   }><strong>Tab, Enter</strong></TableCell>
                    <TableCell {...CELL_DESCRIPTION}><strong>Tab</strong> accepts the field and moves the cursor to the next data field. <br/>  <strong>Enter</strong> accepts the field and moves the cursor to the next <strong>uncertain</strong> data field.</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell {...CELL_NAME       }><strong>Refocus</strong> Field</TableCell>
                    <TableCell {...CELL_SHORTCUT   }><strong> ` </strong> (Grave accent)</TableCell>
                    <TableCell {...CELL_DESCRIPTION}> Returns focus to the last focused field. <br/> <strong>Note:</strong> Not currently supported across detached panes</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
            <Typography variant="h6" sx={{mt:1, mb:1}}>Tables</Typography>
            <TableContainer component={Paper}>
              <Table>
                <TableBody>
                  <TableRow>
                    <TableCell {...CELL_NAME       }><strong>Remove Row</strong></TableCell>
                    <TableCell {...CELL_SHORTCUT   }><strong>Ctrl + Del</strong></TableCell>
                    <TableCell {...CELL_DESCRIPTION}>
                      Set the cursor in any field of the row you want to delete.
                      <br/>Deletes the selected row.
                      <br/><strong>CAUTION:</strong> Deleted rows <strong>cannot</strong> be restored. If you delete a row by accident, you will need to enter its data from scratch.
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell {...CELL_NAME       }><strong>Create Row Above</strong></TableCell>
                    <TableCell {...CELL_SHORTCUT   }><strong>Ctrl + Up Arrow</strong></TableCell>
                    <TableCell {...CELL_DESCRIPTION}>Adds a new row <strong>above</strong> the currently focused row.</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell {...CELL_NAME       }><strong>Create Row Below</strong></TableCell>
                    <TableCell {...CELL_SHORTCUT   }><strong>Ctrl + Down Arrow</strong></TableCell>
                    <TableCell {...CELL_DESCRIPTION}>Adds a new row <strong>below</strong> the currently focused row.</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell {...CELL_NAME       }></TableCell>
                    <TableCell {...CELL_SHORTCUT   }></TableCell>
                    <TableCell {...CELL_DESCRIPTION}><strong>Note:</strong> If you are unable to add a new row, ask your system administrator to change the maximum number of rows for that table (in the system configuration).</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </DialogContent>
          <DialogActions sx={{ backgroundColor: theme.palette.background.secondary[theme.palette.mode] }}>
            <Button { ...BUTTON_CLOSE  } />
          </DialogActions>
        </Dialog> 
      </div>
    );
  }

  //#endregion

  return display();

} export {ShortcutDialog}